import script from "./VNotificationCardContentDefault.vue?vue&type=script&setup=true&lang=ts"
export * from "./VNotificationCardContentDefault.vue?vue&type=script&setup=true&lang=ts"

import "./VNotificationCardContentDefault.vue?vue&type=style&index=0&id=bfec317a&lang=scss"

const __exports__ = script;

export default __exports__